import AsyncRecorder from './AsyncRecorder';
import WrapperInterface from '../utils/WrapperInterface';
import { getWrapperInterface } from '../utils';
import { VIDEO_FPS } from '../data/Config';
import RecordType from '../data/RecordType';
import { RecorderEvent } from './Recorder';
import toWav from 'audiobuffer-to-wav';

// const timeout = (ms:number) => new Promise(res => setTimeout(res, ms));

export default class extends AsyncRecorder {
  audioBuffer: AudioBuffer | null;
  videoWriter: any;
  audioFadeDuration: number;
  type = RecordType.VideoAsync;

  private wi: WrapperInterface;
  constructor(
    canvas: HTMLCanvasElement,
    framesNumber: number,
    duration: number,
    audioBuffer: AudioBuffer | null,
    audioFadeDuration: number,
    offlineFrequencies: Uint8Array[] | null,
    offlineWaveforms: Uint8Array[] | null
  ) {
    super(canvas, framesNumber, duration, offlineFrequencies, offlineWaveforms);

    this.wi = getWrapperInterface()!;

    this.audioBuffer = audioBuffer;
    this.audioFadeDuration = audioFadeDuration;

    const WebMWriter = (window as any).WebMWriter;
    if (WebMWriter) {
      // old
      this.videoWriter = new WebMWriter({
        quality: 1,
        // fileWriter: null,
        fd: this.wi.getVideoTrackFD(),
        frameRate: VIDEO_FPS
      });
    } else {
      // new
      this.videoWriter = this.wi.getNewWebMWriter({
        quality: 1,
        frameRate: VIDEO_FPS
      });
    }
  }

  conversionDidProgress = (progress: number) => {
    this.emit(RecorderEvent.ConversionProgressed, progress);
  };

  update() {
    if (this._currentFrame === this.framesNumber) {
      return;
    }
    this.videoWriter.addFrame(this.canvas);
    this._currentFrame++;
    if (this._currentFrame === this.framesNumber) {
      this.didComplete();
    }
  }

  didComplete() {
    this.emit(RecorderEvent.RecordingEnded);
    this.videoWriter.complete().then((webMBlob: Blob) => {
      if (this.audioBuffer) {
        let audioError: Error | null = null;
        if (this.wi.saveAudioTrackWithWav) {
          let wav = toWav(this.audioBuffer);
          audioError = this.wi.saveAudioTrackWithWav(wav);
        } else {
          audioError = this.wi.saveAudioTrack(this.audioBuffer);
        }
        if (audioError) {
          alert(audioError);
          return;
        }
      }
      /*if (
        this.audioFadeDuration > 0 &&
        this.wi.generateVideoWithFade !== undefined
      ) {
        this.wi
          .generateVideoWithFade(
            this.audioFadeDuration,
            this.duration,
            this.conversionDidProgress
          )
          .then((blob: Blob) => {
            this.emit(RecorderEvent.Complete, blob);
          })
          .catch((e: Error) => {
            alert(e);
          });
      } else {*/
      this.wi
        .generateVideo(
          this.audioBuffer !== null,
          this.duration,
          this.conversionDidProgress
        )
        .then((blob: Blob) => {
          this.emit(RecorderEvent.Complete, URL.createObjectURL(blob));
        })
        .catch((e: Error) => {
          alert(e);
        });
      // }
    });
  }

  cancel() {
    super.cancel();

    this.videoWriter.complete().then((webMBlob: Blob) => {
      // do nothing
      this.wi.clearTemporaryFolder();
    });
  }
}



// WEBPACK FOOTER //
// ./src/video/ElectronRecorder.ts